// Encryption utilities for trusted access

const SECRET_KEY = "trustedAccess" // Can be up to 16 characters for 128-bit key
const ALGORITHM = "AES-CBC"

const getKey = async () => {
  const encoder = new TextEncoder()
  let keyBytes = encoder.encode(SECRET_KEY)

  // Ensure key is 16 bytes (128 bits)
  if (keyBytes.length > 16) {
    keyBytes = keyBytes.slice(0, 16)
  } else if (keyBytes.length < 16) {
    const padded = new Uint8Array(16)
    padded.set(keyBytes)
    keyBytes = padded
  }

  return await crypto.subtle.importKey("raw", keyBytes, { name: ALGORITHM }, false, ["encrypt", "decrypt"])
}

export const encryptStringRandomTrustedAccess = async (data) => {
  const key = await getKey()
  const iv = crypto.getRandomValues(new Uint8Array(16))
  const encoder = new TextEncoder()
  const encrypted = await crypto.subtle.encrypt({ name: ALGORITHM, iv }, key, encoder.encode(data))

  const combined = new Uint8Array(iv.length + encrypted.byteLength)
  combined.set(iv)
  combined.set(new Uint8Array(encrypted), iv.length)

  const base64String = btoa(String.fromCharCode(...new Uint8Array(combined)))
  return encodeURIComponent(base64String)
}

export const decryptStringRandomTrustedAccess = async (encryptedBase64) => {
  const key = await getKey()
  const encryptedData = Uint8Array.from(atob(decodeURIComponent(encryptedBase64)), (c) => c.charCodeAt(0))

  const iv = encryptedData.slice(0, 16)
  const encryptedBytes = encryptedData.slice(16)

  try {
    const decrypted = await crypto.subtle.decrypt({ name: ALGORITHM, iv }, key, encryptedBytes)
    return new TextDecoder().decode(decrypted)
  } catch (err) {
    console.error("Decryption failed:", err)
    return null
  }
}
